import React from 'react';

const DotLottie = ({ size = 250, width, height, className = '' }) => {
  const actualWidth = width || size || 250;
  const actualHeight = height || size || 250;

  return (
    <div className={`d-flex justify-content-center align-items-center py-5 ${className}`}>
      <img
        src="/animations/aegis-loader-360.svg"
        alt="Loading..."
        width={actualWidth}
        height={actualHeight}
        style={{ width: actualWidth, height: actualHeight, objectFit: 'contain' }}
      />
    </div>
  );
};

export default DotLottie;
